export default __webpack_public_path__ + "static/media/Tahoma.c92a832b.ttf";